"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialCovenantPostgresQuerySchema = exports.AssetVerificationQuerySchema = exports.OrgProvidedInputQuerySchema = exports.TAccountsSumQuerySchema = exports.PrincipalBalanceDailyAverageQuerySchema = exports.PrincipalBalancePointInTimeQuerySchema = exports.PostgresParameterReportingPeriodConfigSchema = exports.PostgresParameterOrgProvidedInputKeyConfigSchema = exports.PostgresParameterTAccountsSumConfigSchema = exports.PostgresParameterCapitalProviderSlugsConfigSchema = exports.PostgresParameterAssetVerificationStatusConfigSchema = exports.PostgresParameterFormulaConfigSchema = void 0;
// CommonPostgresQuery main content (Zod schemas and non-namespace exports)
const _imports_1 = require("../_imports");
const AthenaConfig_1 = require("../AthenaConfig");
// ============================================
// Zod schemas for CommonPostgresQuery types
// ============================================
// ParameterConfig schemas
exports.PostgresParameterFormulaConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('formula'),
    engineVersion: _imports_1.z.enum(_imports_1.FormulaEngine.SupportedFormulaEngines),
    formula: _imports_1.z.string(),
});
exports.PostgresParameterAssetVerificationStatusConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('assetVerificationStatusArray'),
    statuses: _imports_1.z.array(_imports_1.z.enum(_imports_1.AssetVerification.AssetVerificationOutput.ReportEntryStatusIterable)),
});
exports.PostgresParameterCapitalProviderSlugsConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('capitalProviderSlugArray'),
    slugs: _imports_1.z.array(_imports_1.z.string()),
});
exports.PostgresParameterTAccountsSumConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('tAccountDetailsArray'),
    accountDetails: _imports_1.z.array(_imports_1.z.object({
        counterpartySlug: _imports_1.z.string(),
        tAccount: _imports_1.z.string(),
    })),
});
exports.PostgresParameterOrgProvidedInputKeyConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('orgProvidedInputKey'),
    key: _imports_1.z.string(),
});
exports.PostgresParameterReportingPeriodConfigSchema = _imports_1.z.object({
    type: _imports_1.z.literal('reportingPeriod'),
    reportingPeriod: _imports_1.ReportingPeriod.ReportingPeriodSchema,
});
// Config schemas (used in Query parameterConfig)
const AssetVerificationQueryConfigSchema = _imports_1.z.object({
    statusFilter: exports.PostgresParameterAssetVerificationStatusConfigSchema,
});
const PrincipalBalancePointInTimeQueryConfigSchema = _imports_1.z.object({
    dateFormula: exports.PostgresParameterFormulaConfigSchema,
});
const PrincipalBalanceDailyAverageQueryConfigSchema = _imports_1.z.object({
    startDateFormula: exports.PostgresParameterFormulaConfigSchema,
    endDateFormula: exports.PostgresParameterFormulaConfigSchema,
    capitalProviderSlugs: exports.PostgresParameterCapitalProviderSlugsConfigSchema,
});
const TAccountsSumQueryConfigSchema = _imports_1.z.object({
    startDateFormula: exports.PostgresParameterFormulaConfigSchema,
    endDateFormula: exports.PostgresParameterFormulaConfigSchema,
    tAccountDetails: exports.PostgresParameterTAccountsSumConfigSchema,
});
const OrgProvidedInputQueryConfigSchema = _imports_1.z.object({
    reportingDateFormula: exports.PostgresParameterFormulaConfigSchema,
    reportingPeriod: exports.PostgresParameterReportingPeriodConfigSchema,
    key: exports.PostgresParameterOrgProvidedInputKeyConfigSchema,
});
// Query schemas
const BasePostgresQuerySchema = _imports_1.z.object({
    name: _imports_1.z.string(),
    variables: _imports_1.z.array(AthenaConfig_1.QueryVariableSchema),
});
exports.PrincipalBalancePointInTimeQuerySchema = BasePostgresQuerySchema.extend({
    type: _imports_1.z.literal('principalBalancePointInTime'),
    parameterConfig: PrincipalBalancePointInTimeQueryConfigSchema,
    resultType: _imports_1.z.literal('primitive'),
});
exports.PrincipalBalanceDailyAverageQuerySchema = BasePostgresQuerySchema.extend({
    type: _imports_1.z.literal('principalBalanceDailyAverage'),
    parameterConfig: PrincipalBalanceDailyAverageQueryConfigSchema,
    resultType: _imports_1.z.literal('primitive'),
});
exports.TAccountsSumQuerySchema = BasePostgresQuerySchema.extend({
    type: _imports_1.z.literal('tAccountsSum'),
    parameterConfig: TAccountsSumQueryConfigSchema,
    resultType: _imports_1.z.literal('primitive'),
});
exports.OrgProvidedInputQuerySchema = BasePostgresQuerySchema.extend({
    type: _imports_1.z.literal('orgProvidedInput'),
    parameterConfig: OrgProvidedInputQueryConfigSchema,
    resultType: _imports_1.z.literal('primitive'),
});
exports.AssetVerificationQuerySchema = BasePostgresQuerySchema.extend({
    type: _imports_1.z.literal('assetVerification'),
    parameterConfig: AssetVerificationQueryConfigSchema,
    resultType: _imports_1.z.literal('array'),
});
// Union schema for all postgres queries used by FinancialCovenant
exports.FinancialCovenantPostgresQuerySchema = _imports_1.z.discriminatedUnion('type', [
    exports.PrincipalBalancePointInTimeQuerySchema,
    exports.PrincipalBalanceDailyAverageQuerySchema,
    exports.TAccountsSumQuerySchema,
    exports.OrgProvidedInputQuerySchema,
]);
//# sourceMappingURL=CommonPostgresQuery.js.map